import { FLAGS } from '@iheartjane/feature-flags';
import { useEffect } from 'react';

import { trackAbTest } from '@jane/bloom/services/tracking/track';

import { useRootLoaderData } from './useRootLoaderData';

/**
 * A/B test for the Leave Review modal: the step-by-step wizard (variant) vs.
 * the single form (control).
 *
 * Returns whether to show the wizard. Exposure is tracked each time `isOpen`
 * turns true, so users who never open the modal don't dilute the experiment.
 */
export const useLeaveReviewAbTest = (isOpen: boolean): boolean => {
  const { featureFlags } = useRootLoaderData();
  const isLeaveReviewEnabled = Boolean(featureFlags[FLAGS.c2LeaveReview]);
  const showWizard = Boolean(featureFlags[FLAGS.c2LeaveReviewWizard]);
  const trackExposure = isOpen && isLeaveReviewEnabled;

  useEffect(() => {
    if (!trackExposure) return;
    trackAbTest({
      enabled: showWizard,
      experiment: 'Leave Review Modal',
    });
  }, [trackExposure, showWizard]);

  return isLeaveReviewEnabled && showWizard;
};
